module.exports = __webpack_public_path__ + "static/media/Rebobinables.cc46c252.pdf";